import React, { useEffect, useState } from 'react';
import { describeCron, isValidCron } from '../../../lib/formatters/cron';
import { CRON_PRESETS } from '../../../mocks/scheduler';

// Edit + validate cron expressions (T7.7). Invalid input is rejected inline:
// Save stays disabled and the summary reads "Invalid schedule".
function CronEditor({ job, onSave, onCancel }) {
  const [draft, setDraft] = useState(job.cron);
  const [touched, setTouched] = useState(false);
  const valid = isValidCron(draft);

  useEffect(() => {
    setDraft(job.cron);
    setTouched(false);
  }, [job.id, job.cron]);

  return (
    <form
      className="cron-editor"
      onSubmit={(event) => {
        event.preventDefault();
        if (valid) onSave(job.id, draft.trim());
      }}
    >
      <label htmlFor={`cron-${job.id}`}>Schedule (cron) — {job.agentName} · {job.title}</label>
      <input
        aria-invalid={touched && !valid}
        className={`mono-input cron-input ${touched && !valid ? 'is-invalid' : ''}`}
        id={`cron-${job.id}`}
        onBlur={() => setTouched(true)}
        onChange={(event) => setDraft(event.target.value)}
        spellCheck="false"
        value={draft}
      />
      <p className={`cron-summary ${valid ? '' : 'cron-summary-error'}`}>
        {describeCron(draft)}
      </p>
      <div className="cron-presets">
        {Object.entries(CRON_PRESETS).map(([key, expression]) => (
          <button
            key={key}
            onClick={() => setDraft(expression)}
            title={expression}
            type="button"
          >
            {key.replace(/([A-Z])/g, ' $1').toLowerCase()}
          </button>
        ))}
      </div>
      <div className="cron-editor-actions">
        <button className="primary-button" disabled={!valid} type="submit">
          Save schedule
        </button>
        <button className="ghost-button" onClick={onCancel} type="button">Cancel</button>
      </div>
    </form>
  );
}

export default CronEditor;
